module.exports = {
	"conditions": [
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can climb several flights",
					"example2": "Can climb a few stairs",
					"example3": "Cannot use stairs",
					"help_text": "",
					"id": 2,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is climbing stairs? "
				}
			],
			"id": 7,
			"name": "Mobility",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can read a receipt",
					"example2": "Can read a bathroom sign",
					"example3": "Can read a billboard ",
					"help_text": "",
					"id": 3,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is reading? (seeing the text)"
				},
				{
					"example1": "No issues with glare sensitivity.",
					"example2": "Slightly sensitive to glare. ",
					"example3": "Extremely sensitive to glare. ",
					"help_text": "",
					"id": 9,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the severity of glare sensitivity?"
				},
				{
					"example1": "Have difficulty maneuvering around cracks in pavement ",
					"example2": "Have difficulty maneuvering on curbs and stairs  ",
					"example3": "Have difficulty maneuvering around large objects like trashcans ",
					"help_text": "",
					"id": 10,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is walking? (vision) "
				},
				{
					"example1": "No color blindness experienced.",
					"example2": "Slight color blindness experienced. ",
					"example3": "Severe color blindness experienced. ",
					"help_text": "",
					"id": 11,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the severity of color blindness?"
				}
			],
			"id": 8,
			"name": "Vision",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can hear a whisper",
					"example2": "Can hear a conversation",
					"example3": "Can hear a vacuum ",
					"help_text": "",
					"id": 4,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is hearing?"
				}
			],
			"id": 9,
			"name": "Hearing",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Have difficulty remembering information day to day. ",
					"example2": "Have difficulty remembering information for a few hours. ",
					"example3": "Have difficulty remembering information for a few minutes",
					"help_text": "",
					"id": 5,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is remembering? "
				},
				{
					"example1": "Have difficulty with complex directions",
					"example2": "Have difficulty with 5 or more step directions",
					"example3": "Have difficulty following 2 step directions",
					"help_text": "",
					"id": 6,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is following directions? "
				},
				{
					"example1": "Can Making change",
					"example2": "Can count out objects",
					"example3": "Unable to work with numbers",
					"help_text": "",
					"id": 7,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is working with numbers? "
				},
				{
					"example1": "Can find your way around a shopping mall",
					"example2": "Can find your way around a small store",
					"example3": "Become lost or disoriented very easily ",
					"help_text": "",
					"id": 8,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is navigating? "
				}
			],
			"id": 10,
			"name": "Cognition",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can speak several sentences",
					"example2": "Can speak a few words",
					"example3": "Can say \"yes\" and \"no\" only",
					"help_text": "",
					"id": 12,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is speaking? "
				},
				{
					"example1": "Can understand long sentences",
					"example2": "Can understand most short sentences",
					"example3": "Can understands a few specific words",
					"help_text": "",
					"id": 13,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is understanding (spoken) speech? "
				},
				{
					"example1": "Can read paragraphs",
					"example2": "Can read simple sentences",
					"example3": "Can read some words ",
					"help_text": "",
					"id": 14,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is reading? "
				}
			],
			"id": 12,
			"name": "Communicating",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Difficulty retrieving objects from very high or low shelves ",
					"example2": "Difficulty retrieving objects at shoulder level  ",
					"example3": "Difficulty picking up objects from your lap ",
					"help_text": "",
					"id": 15,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is reaching objects off shelves?"
				},
				{
					"example1": "Can lift a 20 pound box",
					"example2": "Can lift a gallon of milk",
					"example3": "Can lift a cup of water ",
					"help_text": "",
					"id": 16,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is lifting items? "
				},
				{
					"example1": "Can pick up a quarter ",
					"example2": "Can use a pencil",
					"example3": "Can pick up a cup of water ",
					"help_text": "",
					"id": 17,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is it to grasp items? "
				},
				{
					"example1": "No tremors",
					"example2": "Moderate tremors",
					"example3": "Tremors that limit ability to complete day to day tasks",
					"help_text": "",
					"id": 29,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the severity of tremors experienced? (UE)"
				}
			],
			"id": 13,
			"name": "Upper Extremity",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can walk a mile",
					"example2": "Can walk around Walmart ",
					"example3": "I cannot walk independently",
					"help_text": "",
					"id": 1,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is walking? (distance) "
				},
				{
					"example1": "Can stand up from a booth at a restaurant ",
					"example2": "Can stand up from a toilet ",
					"example3": "Can stand up for a chair with arm rests ",
					"help_text": "",
					"id": 18,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is standing up? "
				},
				{
					"example1": "Can stand for more than 30 minutes ",
					"example2": "Can stand for 5 minutes",
					"example3": "Can stand for 1-2 minutes max ",
					"help_text": "",
					"id": 19,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is standing? "
				},
				{
					"example1": "Can walk safely on sand",
					"example2": "Can walk safely on a hard dirt path",
					"example3": "Can walk safely on tile ",
					"help_text": "",
					"id": 20,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is walking? (balance) "
				},
				{
					"example1": "No tremors",
					"example2": "Moderate tremors",
					"example3": "Tremors that limit ability to complete day to day tasks",
					"help_text": "",
					"id": 30,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the severity of tremors experienced? (LE)"
				}
			],
			"id": 14,
			"name": "Lower Extremity ",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can attend a rock concert",
					"example2": "Can attend a loud restaurant ",
					"example3": "Can tolerate quiet background noise (like a fan) ",
					"help_text": "",
					"id": 21,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of sound sensitivity? "
				},
				{
					"example1": "Can tolerate a bright store such as Walmart",
					"example2": "Can tolerate being in a office building ",
					"example3": "Can tolerate a restaurant at night ",
					"help_text": "",
					"id": 22,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of light sensitivity?"
				},
				{
					"example1": "Can tolerate a smelly trash can",
					"example2": "Can tolerate others wearing perfume or cologne   ",
					"example3": "Can tolerate the smell of food at a restaurant",
					"help_text": "",
					"id": 23,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of sensitivity to smell? "
				},
				{
					"example1": "Can tolerate being outside in the middle of winter/summer",
					"example2": "Can tolerate a very warm (>90) or very cold (<60) room",
					"example3": "Always too hot or too cold",
					"help_text": "",
					"id": 24,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of sensitivity to variations in temperature? "
				},
				{
					"example1": "Can attend a rock concert",
					"example2": "Can attend a busy shopping mall",
					"example3": "Can attend a busy restaurant",
					"help_text": "",
					"id": 25,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of sensitivity to stimulating environments?"
				},
				{
					"example1": "Can attend a rock concert",
					"example2": "Can attend a busy shopping mall",
					"example3": "Can attend a busy restaurant",
					"help_text": "",
					"id": 26,
					"max_anchor": "Severe",
					"min_anchor": "None",
					"order": 1000,
					"prompt": "What is the level of sensitivity to stimulating environments?"
				}
			],
			"id": 15,
			"name": "Sensory Sensitivities ",
			"order": 1000
		},
		{
			"detail": "",
			"functions": [
				{
					"example1": "Can pick up an object from the floor",
					"example2": "Can pick up an object from a low shelf",
					"example3": "Can pick up a paper from a table ",
					"help_text": "",
					"id": 27,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is bending the head/neck/back? "
				},
				{
					"example1": "Can turn head to cross street",
					"example2": "Can look down to write",
					"example3": "Can only turn head slightly",
					"help_text": "",
					"id": 28,
					"max_anchor": "Unable",
					"min_anchor": "Easy",
					"order": 1000,
					"prompt": "How difficult is moving the head/neck/back? "
				}
			],
			"id": 16,
			"name": "Head, Neck, or Back",
			"order": 1000
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Profile/Conditions.json
// module id = 342
// module chunks = 0